import React, { useContext } from 'react'
import PricingCard from '../../components/pricingCard/card'
import CustomImage from '../../components/customImage/customImage'
import { getImage } from '../../utils/helper'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'

const IntentPricingPlansFive = ({ data }) => {
  const { accountObj } = useContext(AppContext)

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className="w-full h-full xl:flex justify-between items-center relative "
      style={{ background: getStyleValue('component_background', 'primary_color', '#000000') }}
    >
      <div className="lg:w-[35%] hidden xl:block relative">
        <CustomImage
          imageUrl={getImage(accountObj?.cf_domain_name, data.image_s3_key)}
          imgClass="w-full h-full"
          loaderClass={'w-full h-full'}
          imgAlt={`data.team1.logo`}
        />
        <div
          style={{
            zIndex: '20',
            backgroundImage: `linear-gradient(to right, transparent 10%, ${getStyleValue(
              'component_background',
              'primary_color',
              '#000000',
            )} 100%)`,
          }}
          className="absolute top-0 right-0 h-full w-1/3 "
        ></div>
      </div>
      <div className="relative xl:absolute z-20 w-full top-0 lg:mt-3">
        <div
          className={`${getStyleValue(
            'section_heading',
            'font_format',
            'font-bold',
          )} w-full text-xl sm:text-2xl md:text-3xl xl:text-[30px] text-center `}
          style={{
            fontFamily: getStyleValue('section_heading', 'font', ''),
            color: getStyleValue('section_heading', 'color', '#e2e2e2'),
          }}
        >
          <span>{data?.section_title}</span>
        </div>
        <div
          className="relative w-full md:w-4/5 lg:w-3/4 xl:w-[1270px] h-full  md:mx-8 md:my-6 lg:mx-auto lg:my-[22px]  xl:mr-[140px] flex justify-between"
          // style={{ border: '1px solid #16ffff ' }}
        >
          <div className="w-[21%] xl:w-[13%] flex flex-col  mt-2">
            {/* {!isEmpty(data?.features_data) &&
              data?.features_data.map((label, index) => {
                return label.text ? (
                  <div key={index} className="flex items-center pl-4 border">
                    <span className="text-white text-left whitespace-nowrap">{label.text}</span>
                  </div>
                ) : null
              })} */}
          </div>

          <div
            className="flex justify-start w-[86%] h-full overflow-x-auto"
            style={{ overflowY: 'hidden' }}
          >
            {!isEmpty(data?.column_data) &&
              data?.column_data.map((info, index) => (
                <PricingCard
                  key={index}
                  plan={info}
                  featureData={data?.features_data || []}
                  columnIndex={index}
                  mainStyleConfig={data?.style_config}
                  iconType={data?.icon_style || 'TYPE1'}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
export default IntentPricingPlansFive
